// Centralized UI tokens + reusable sx presets for WhatsApp Business screens.
// Keep this file small and stable; other components should import from here.

export const WB_UI = {
  radius: {
    card: 2,
    chip: 2,
    button: 2,
  },
  spacing: {
    pageTop: 2,
    sectionGap: 3,
    cardPadding: 2,
    tableRowPy: 1.25,
  },
  color: {
    cardBg: "rgba(255,255,255,0.9)",
    cardBgStrong: "rgba(255,255,255,0.95)",
    border: "rgba(0,0,0,0.08)",
    tableHeadBg: "#1a2333",
    primaryButtonBg: "#111827",
    primaryButtonHoverBg: "#020617",
    softInfoBg: "#f3f4f6",
    softSuccessBg: "#e8f5e9",
    softWarningBg: "#fff3e0",
    softPrimaryBg: "#e3f2fd",
    accentGreen: "#2e7d32",
    accentOrange: "#ed6c02",
    accentBlue: "#1976d2",
    whatsappDark: "#075e54",
    whatsappGreen: "#25d366",
  },
  typography: {
    pageTitle: {
      fontWeight: 800,
      letterSpacing: "-0.02em",
      lineHeight: 1.2,
    },
    sectionTitle: {
      fontWeight: 700,
      letterSpacing: "-0.01em",
      lineHeight: 1.25,
    },
    bodyStrong: {
      fontWeight: 600,
    },
    caption: {
      fontSize: "0.78rem",
    },
  },
};

export const WB_SX = {
  page: {
    mt: WB_UI.spacing.pageTop,
  },
  headerRow: {
    mb: WB_UI.spacing.sectionGap,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 2,
    width: "100%",
  },
  pageTitle: {
    ...WB_UI.typography.pageTitle,
    color: "text.primary",
    mb: 2,
    fontSize: { xs: "1.1rem", md: "1.35rem" },
  },
  sectionTitle: {
    ...WB_UI.typography.sectionTitle,
    color: "text.primary",
  },
  pageSubtitle: {
    color: "text.secondary",
  },
  card: {
    borderRadius: WB_UI.radius.card,
    border: `1px solid ${WB_UI.color.border}`,
    backgroundColor: WB_UI.color.cardBg,
  },
  cardContent: {
    p: WB_UI.spacing.cardPadding,
  },
  infoBox: {
    mt: 2,
    p: 2,
    borderRadius: WB_UI.radius.card,
    border: `1px solid ${WB_UI.color.border}`,
    backgroundColor: WB_UI.color.softInfoBg,
  },
  tableContainer: {
    borderRadius: WB_UI.radius.card,
    border: `1px solid ${WB_UI.color.border}`,
    overflow: "hidden",
    backgroundColor: "#fff",
  },
  tableHeadCell: {
    backgroundColor: WB_UI.color.tableHeadBg,
    color: "#fff",
    fontWeight: 700,
    borderBottom: "none",
    whiteSpace: "nowrap",
  },
  tableRow: {
    "& > td": {
      py: WB_UI.spacing.tableRowPy,
    },
  },
  primaryButton: {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: WB_UI.radius.button,
    px: 3,
    backgroundColor: WB_UI.color.primaryButtonBg,
    "&:hover": {
      backgroundColor: WB_UI.color.primaryButtonHoverBg,
    },
  },
  secondaryButton: {
    textTransform: "none",
    borderRadius: WB_UI.radius.button,
    fontWeight: 600,
  },
  tabs: {
    mb: 3,
    "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
    "& .Mui-selected": { color: WB_UI.color.primaryButtonBg },
    "& .MuiTabs-indicator": { backgroundColor: WB_UI.color.primaryButtonBg },
  },
  categoryChip: (category) => ({
    fontWeight: 700,
    backgroundColor:
      category === "AUTHENTICATION"
        ? WB_UI.color.softSuccessBg
        : category === "MARKETING"
        ? WB_UI.color.softWarningBg
        : WB_UI.color.softPrimaryBg,
    color:
      category === "AUTHENTICATION"
        ? WB_UI.color.accentGreen
        : category === "MARKETING"
        ? WB_UI.color.accentOrange
        : WB_UI.color.accentBlue,
  }),
};
